import { render, staticRenderFns } from "./trainingsystem_s4.vue?vue&type=template&id=aa975310&scoped=true&"
import script from "./trainingsystem_s4.vue?vue&type=script&lang=js&"
export * from "./trainingsystem_s4.vue?vue&type=script&lang=js&"
import style0 from "./trainingsystem_s4.vue?vue&type=style&index=0&id=aa975310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa975310",
  null
  
)

export default component.exports